import { Routes } from '@angular/router';

import { PadelComponent } from './padel/padel.component';
import { PackagesType01Component } from './packages-type01/packages-type01component';
import { PackagesType02Component } from './packages-type02/packages-type02component';
import { PackagesType03Component } from './packages-type03/packages-type03component';
import { PackagesType04Component } from './packages-type04/packages-type04component';
import { BlackFridaySpecialsComponent } from './black-friday-specials/black-friday-specials.component';

export default [
    {
        path: '',
        component: PackagesType01Component,
    },
    {
        path: 'events',
        component: PackagesType02Component,
    },
    {
        path: 'sports',
        component: PackagesType04Component,
    },
    {
        path: 'rail',
        component: PackagesType03Component,
    },
    {
        path: 'padel',
        component: PadelComponent,
    },
    {
        path: 'black-friday-specials',
        component: BlackFridaySpecialsComponent,
    },
] as Routes;
